/**
 * Waits for a DOM element matching the given selector to appear.
 * Uses MutationObserver for efficient detection.
 * Resolves with the element or null on timeout.
 */
export function waitForElement(selector: string, timeout = 5000): Promise<HTMLElement | null> {
  return new Promise((resolve) => {
    const existing = document.querySelector<HTMLElement>(selector);
    if (existing) {
      resolve(existing);
      return;
    }

    let timeoutId: ReturnType<typeof setTimeout> | null = null;

    const observer = new MutationObserver(() => {
      const el = document.querySelector<HTMLElement>(selector);
      if (el) {
        observer.disconnect();
        if (timeoutId) clearTimeout(timeoutId);
        resolve(el);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    timeoutId = setTimeout(() => {
      observer.disconnect();
      console.warn(`[waitForElement] Timeout waiting for "${selector}"`);
      resolve(null);
    }, timeout);
  });
}
